import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-paper pb-20 md:pb-28" aria-labelledby="garantia-title" data-id="element-68" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-69" data-mp="22369bvhw27tb">
        <div className="grid gap-8 rounded-3xl bg-accent-soft px-7 py-10 md:grid-cols-[auto_minmax(0,1fr)] md:items-start md:gap-10 md:px-12 md:py-14" data-id="element-70" data-mp="222n1j7lyczt0">
          <ShieldCheckIcon className="h-12 w-12 shrink-0 text-accent-dark" strokeWidth={1.75} aria-hidden="true" data-id="element-71" data-mp="19e7q0v214zmf" />
          <div data-id="element-72" data-mp="14dl4pk0e8ico">
            <h2 id="garantia-title" className="text-3xl font-extrabold tracking-tightest text-ink md:text-4xl" data-id="element-73" data-mp="1j4k7ufigmeov">
              Garantía 7 días — sin preguntas
            </h2>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-ink" data-id="element-74" data-mp="qnpy2sp0u824">
              Abrís los tomos. Los usás en tu consultorio. Si en 7 días no es lo que esperabas:
              devolución del 100%, sin formularios, sin drama.
            </p>
            <p className="mt-5 text-sm font-bold uppercase tracking-[0.14em] text-accent-dark" data-id="element-75" data-mp="oz9liwev73jg">
              Tasa de devoluciones: menos del 1%
            </p>
          </div>
        </div>
      </div>
    </section>;
}